import { createSlice } from "@reduxjs/toolkit";

interface Ityping {
  message: string;
  chatId: string;
  type: string;
}

const initialState: Ityping = {
  chatId: "",
  message: "",
  type: "typing"
};

const slice = createSlice({
  name: "typing",
  initialState: initialState,
  reducers: {
    userTyping: (state, action) => {
      state = action.payload;
      return state;
    }
  }
});

export const { userTyping } = slice.actions;

export default slice.reducer;
